import { MutOpt } from '@/app/api';
import { queryClient } from '@/lib/query-client';
import { createQueryKeys } from '@/lib/query-factory';
import {
  DefaultError,
  MutationOptions,
  queryOptions,
} from '@tanstack/react-query';
import { toast } from 'sonner';
import * as api from './projects.api';
import { Project } from '@certhon/models';

const keys = createQueryKeys('projects');

export const projectQueries = {
  keys,

  list: (qry?: api.ProjectsQuery) =>
    queryOptions({
      queryKey: keys.list(qry),
      queryFn: () => api.fetchProjects(qry),
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: keys.detail(id),
      queryFn: () => api.fetchProject(id),
      enabled: !!id,
    }),
};

export const projectMutations = {
  follow: (): MutationOptions<
    Project,
    DefaultError,
    { projectId: number; userId: number }
  > => ({
    mutationFn: ({ userId, projectId }) =>
      api.patchProject(projectId, { associate: userId }),
    onSuccess: ({ recnum }) => {
      queryClient.invalidateQueries({ queryKey: keys.detail(recnum) });
      queryClient.invalidateQueries({ queryKey: keys.lists() });
      toast.success('Following project');
    },
    onError: (error: Error) => {
      toast.error('Failed to follow project', {
        description: error.message,
      });
    },
  }),
  unfollow: (): MutationOptions<
    Project,
    DefaultError,
    { projectId: number; userId: number }
  > => ({
    mutationFn: ({ userId, projectId }) =>
      api.patchProject(projectId, { dissociate: userId }),
    onSuccess: ({ recnum }) => {
      queryClient.invalidateQueries({ queryKey: keys.detail(recnum) });
      queryClient.invalidateQueries({ queryKey: keys.lists() });
      toast.success('Unfollowed project');
    },
    onError: (error: Error) => {
      toast.error('Failed to unfollow project', {
        description: error.message,
      });
    },
  }),
};
